import React, {
  ReactComponentElement,
  useContext,
  useLayoutEffect,
  useRef
} from "react";
import { useSelector } from "react-redux";

import { getDimensionFromCSSVar } from "seneca-common/utils/functions";

import { SIDEBAR_MENU_ITEM_HEIGHT } from "features/classroom/features/sidebar/components/SidebarMenuItem/SidebarMenuItem";
import { SidebarContext } from "features/classroom/features/sidebar/SidebarContextProvider";
import { TAB_BAR_HEIGHT_WITH_MARGINS } from "features/common/tabs/components/TabBar";
import { getUserTypeHasTopbar } from "features/user/selectors";

import styles from "./SidebarContentWrapperOuter.module.scss";

type Props = {
  children:
    | ReactComponentElement<any, any>
    | ReactComponentElement<any, any>[]
    | any;
  dataTest?: string;
  hasTabBar?: boolean;
};

export default function SidebarContentWrapperOuter({
  children,
  dataTest,
  hasTabBar = true
}: Props) {
  const hasTopbar = useSelector((state: any) => getUserTypeHasTopbar(state));
  const topbarHeight = getDimensionFromCSSVar(styles.var_topbarHeight);
  const viewportHeight = window.innerHeight;

  const { visibleItems } = useContext(SidebarContext);
  const numVisibleMenuItems = Object.values(visibleItems).reduce(
    (acc, value) => acc + Number(value),
    0
  );
  const menuItemsHeight = numVisibleMenuItems * SIDEBAR_MENU_ITEM_HEIGHT;
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (ref.current) {
      const elementHeight =
        viewportHeight -
        114 -
        menuItemsHeight -
        (hasTopbar ? topbarHeight : 0) -
        (hasTabBar ? TAB_BAR_HEIGHT_WITH_MARGINS : 0);
      ref.current.style.height = `${elementHeight}px`;
    }
  }, [hasTabBar, hasTopbar, menuItemsHeight, topbarHeight, viewportHeight]);

  return (
    <div ref={ref} data-test={dataTest} className={styles.outer}>
      {children}
    </div>
  );
}
